import { useState } from "react";
import { Row, Card, ListGroup, Button, Modal, Form, Alert } from "react-bootstrap";
import LableValueDisplay from "../Client/LableValueDisplay";
import { useApiClient } from '../../ApiService/useApiClient';

const AgentLoginDetails = ({ data }) => {
  const api = useApiClient();

  const [showModal, setShowModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handlePasswordChange = async () => {
    setError("");
    setSuccessMsg("");

    if (!newPassword || !confirmPassword) {
      setError("Please fill in both password fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

   try {
        const frmFormData = new FormData();
        frmFormData.append("agentID", data.agentId);
        frmFormData.append("newPassword", newPassword);

        const response = await api.post("HMCareStaff/reset-password", frmFormData);

        //console.log(response.data);

        if (response?.data) {
          //setSuccessMsg("Password has been changed successfully.");
          setSuccessMsg(response.data.message);
          setNewPassword("");
          setConfirmPassword("");
          setShowModal(false);
        } else {
          const result = await response.json();
          setError(result?.message || "Failed to reset password.");
        }
      } catch (err) {
        console.error(err);
        setError("Error occurred while changing password.");
      }
  };


  if (!data) return null;

//console.log(data);

  return (
    <>
      <Row>
        <div className="col-md-6">
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <LableValueDisplay name={"Username"} value={data.emailId} />
              </ListGroup.Item>
              <ListGroup.Item className="d-flex justify-content-between align-items-center">
                <LableValueDisplay name={"Password"} value={"************************"} />
                <Button variant="link" size="sm" onClick={() => setShowModal(true)}>
                  Change Password
                </Button>
              </ListGroup.Item>
              <ListGroup.Item>
                <LableValueDisplay
                  name={"Access Level"}
                  value={data.isAdmin === "1" ? "Administrator" : "Staff"}
                />
              </ListGroup.Item>
              <ListGroup.Item>
                <LableValueDisplay
                  name={"Status"}
                  value={data.status == "1" ? "Active" : "Inactive"}
                />
              </ListGroup.Item>
              <ListGroup.Item>
                <LableValueDisplay name={"Last Login"} value={data.lastLoginTime} />
              </ListGroup.Item>
            </ListGroup>
          </Card>
          {successMsg && <Alert variant="success" className="mt-3">{successMsg}</Alert>}
        </div>
      </Row>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handlePasswordChange}>
            Change Password
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AgentLoginDetails;



// import { Row, Col } from "react-bootstrap"
// import { Card, ListGroup } from "react-bootstrap"
// import LableValueDisplay from "../Client/LableValueDisplay"

// const AgentLoginDetails = ({data}) => {

   
//   return (
     
//     <>
// <Row>
//   <div className="col-md-6">
//   <Card>
//       <ListGroup variant="flush">
//           <ListGroup.Item><LableValueDisplay name={"Username"} value={data.emailId} /></ListGroup.Item>
//           <ListGroup.Item><LableValueDisplay name={"Password"} value={"************************"} /></ListGroup.Item>          
//           <ListGroup.Item><LableValueDisplay name={"Access Level"} value={(data.isAdmin=="1"?"Administrator":"Staff")} /></ListGroup.Item>
//           <ListGroup.Item><LableValueDisplay name={"Status"} value={(data.status="1"?"Active":"Inactive")} /></ListGroup.Item> 
//           <ListGroup.Item><LableValueDisplay name={"Last Login"} value={data.lastLoginTime} /></ListGroup.Item>                      
//       </ListGroup>
//   </Card>
//   </div>
   
// </Row>
// <br></br>
    
//     </>
//   )
// }

// export default AgentLoginDetails